export const PasswordConstants = {
  FETCH_PASSWORD_REQUEST: "FETCH_PASSWORD_REQUEST",
  FETCH_PASSWORD_SUCCESS: "FETCH_PASSWORD_SUCCESS",
  FETCH_PASSWORD_FAILURE: "FETCH_PASSWORD_FAILURE",
  ADD_PASSWORD_REQUEST: "ADD_PASSWORD_REQUEST",
  ADD_PASSWORD_SUCCESS: "ADD_PASSWORD_SUCCESS",
  ADD_PASSWORD_FAILURE: "ADD_PASSWORD_FAILURE",
  PASSWORD_SEARCH_REQUEST: "PASSWORD_SEARCH_REQUEST",
  PASSWORD_SEARCH_SUCCESS: "PASSWORD_SEARCH_SUCCESS",
  PASSWORD_SEARCH_FAILURE: "PASSWORD_SEARCH_FAILURE",
  PASSWORD_AUTO_SEARCH_REQUEST: "PASSWORD_AUTO_SEARCH_REQUEST",
  PASSWORD_AUTO_SEARCH_SUCCESS: "PASSWORD_AUTO_SEARCH_SUCCESS",
  PASSWORD_AUTO_SEARCH_FAILURE: "PASSWORD_AUTO_SEARCH_FAILURE",
  GET_PASSWORD_REQUEST: "GET_PASSWORD_REQUEST",
  GET_PASSWORD_SUCCESS: "GET_PASSWORD_SUCCESS",
  GET_PASSWORD_FAILURE: "GET_PASSWORD_FAILURE",
  UPDATE_PASSWORD_REQUEST: "UPDATE_PASSWORD_REQUEST",
  UPDATE_PASSWORD_SUCCESS: "UPDATE_PASSWORD_SUCCESS",
  UPDATE_PASSWORD_FAILURE: "UPDATE_PASSWORD_FAILURE",
  DOWNLOAD_PASSWORD_REQUEST: "DOWNLOAD_PASSWORD_REQUEST",
  DOWNLOAD_PASSWORD_SUCCESS: "DOWNLOAD_PASSWORD_SUCCESS",
  DOWNLOAD_PASSWORD_FAILURE: "DOWNLOAD_PASSWORD_FAILURE",
  UPLOAD_PASSWORD_REQUEST: "UPLOAD_PASSWORD_REQUEST",
  UPLOAD_PASSWORD_SUCCESS: "UPLOAD_PASSWORD_SUCCESS",
  UPLOAD_PASSWORD_FAILURE: "UPLOAD_PASSWORD_FAILURE",
};
